import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://mapmykid.com";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Client-side per-route SEO: unique title, description, canonical and OG/Twitter tags.
export default function Seo({ title, description, image }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (image) {
      const abs = image.startsWith("http") ? image : ORIGIN + image;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:image", abs);
    }
    const url = ORIGIN + (pathname === "/" ? "/" : pathname);
    setMeta("property", "og:url", url);
    setCanonical(url);
  }, [title, description, image, pathname]);

  return null;
}
